<template>
  <BaseButton
    :size="size"
    :data-testid="dataTestId"
    class="tw:font-bold tw:border tw:bg-blue-700 tw:border-blue-700 tw:text-white tw:text-wrap"
    v-bind="$attrs"
  >
    <slot />
  </BaseButton>
</template>

<script setup>
import BaseButton from './BaseButton.vue'
defineProps({
  size: {
    type: String,
    default: 'big',
  },
  dataTestId: {
    type: String,
    default: '',
  },
})
</script>

<style scoped>
@media (hover: hover) and (pointer: fine) {
  button:hover {
    background-color: var(--tw-color-blue-800);
    border-color: var(--tw-color-blue-800);
  }
}
button:disabled {
  background-color: var(--tw-color-blue-200);
  border-color: var(--tw-color-blue-200);
}
</style>
